import React, { useEffect, useState } from "react";
// import DatePicker from "react-datepicker";
import Totalincomechart from "../Charts/Totalincomechart";
import { useQuery } from "@apollo/react-hooks";
import { monoClient } from "../../apolloClient";
import { GET_TICKET_INCOME_LINE_CHART } from "../../query/getDashBoardData";
import moment from "moment";

const TotalIncome = ({ diffDay, startDate, endDate, isPrint }) => {
  const { data } = useQuery(GET_TICKET_INCOME_LINE_CHART, {
    client: monoClient,
    fetchPolicy: "cache-and-network",
    variables: {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).add(1, "day").format("YYYY-MM-DD"),
      council_profile_id: localStorage.getItem("profile_id"),
    },
  });

  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    if (data && data?.getCouncilDashboardTotalTicketsIncomeLineChart?.length) {
      let arr = [
        {
          id: "council",
          data: [],
        },
      ];
      for (
        let i = 0;
        i < data?.getCouncilDashboardTotalTicketsIncomeLineChart?.length;
        i++
      ) {
        arr[0].data.push({
          x: new Date(
            data?.getCouncilDashboardTotalTicketsIncomeLineChart[i]?.x
          ),
          y: data?.getCouncilDashboardTotalTicketsIncomeLineChart[i]?.y,
        });
      }

      setGraphData(arr);

      // setGraphData([
      //   {
      //     id: "jhbjh",
      //     data: [
      //       {
      //         x: new Date(moment().subtract(1, "days").format()),
      //         y: 1000,
      //       },
      //       {
      //         x: new Date(moment().subtract(2, "days").format()),
      //         y: 2000,
      //       },
      //       {
      //         x: new Date(moment().subtract(3, "days").format()),
      //         y: 3000,
      //       },
      //       {
      //         x: new Date(moment().subtract(4, "days").format()),
      //         y: 5000,
      //       },
      //     ],
      //   },
      // ]);
    }
  }, [data]);

  return (
    <div className="totalincome">
      <div className="totalincome dashboar-left-box">
        <div className="title">
          {isPrint ? (
            <span
              style={{
                color: "black",
                fontWeight: "600",
                fontSize: "19px",
              }}
            >
              Total Tickets Income
            </span>
          ) : (
            <h3>Total Tickets Income</h3>
          )}
        </div>
        <div
          className="line-chart-row"
          style={isPrint ? { marginTop: "5%", width: "565px" } : {}}
        >
          <Totalincomechart data={graphData} diffOfDays={diffDay} />
        </div>
      </div>
    </div>
  );
};
export default TotalIncome;
